var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3195_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5547 40C34.839 40 41.5547 33.2843 41.5547 25C41.5547 16.7157 34.839 10 26.5547 10C18.2704 10 11.5547 16.7157 11.5547 25C11.5547 33.2843 18.2704 40 26.5547 40Z",
    fill: "#E21A20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6684 22.6373C34.5536 21.0553 34.2653 19.4217 32.2426 19.3022C28.4527 19.0861 24.6536 19.0861 20.8637 19.3022C18.8411 19.4194 18.5528 21.0553 18.4379 22.6373C18.3202 24.2101 18.3202 25.7895 18.4379 27.3623C18.5528 28.9444 18.8411 30.578 20.8637 30.6975C24.6536 30.9136 28.4527 30.9136 32.2426 30.6975C34.2653 30.5803 34.5536 28.9444 34.6684 27.3623C34.7862 25.7895 34.7862 24.2101 34.6684 22.6373ZM24.9137 27.1092V22.4217L29.3668 24.7655L24.9137 27.1092Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3195_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(11.5547 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.a7647a8f96bfe1a6e26ed489be6bf02f.svg";
export { ForwardRef as ReactComponent };